import { isEmptyString } from '@/utils/string';

/** Pure rule for when the Agent Beta label is shown — unit-tested without React or copilot session. */
export function shouldShowAgentBetaLabel(sessionName: string | null | undefined, isAgentV2: boolean): boolean {
  return isAgentV2 && isEmptyString(sessionName);
}
